module.exports = __webpack_public_path__ + "img/c5.9f2fe20e.png";